import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import HomeV1 from "./pages/HomeV1";
import HomeV2 from "./pages/HomeV2";
import HomeV3 from "./pages/HomeV3";

function App() {
  // Remove any externally injected badges from the DOM
  useEffect(() => {
    const removeBadges = () => {
      // Find and remove elements containing "Emergent" text
      const allElements = document.querySelectorAll('a, div, span, p');
      allElements.forEach(el => {
        if (el.textContent && el.textContent.toLowerCase().includes('emergent')) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.position = 'absolute';
          el.style.pointerEvents = 'none';
          el.remove();
        }
      });
      
      // Also target any links to emergent domains
      const emergentLinks = document.querySelectorAll('a[href*="emergent"], a[href*="Emergent"]');
      emergentLinks.forEach(el => {
        el.style.display = 'none';
        el.remove();
      });
    };

    // Run immediately
    removeBadges();
    
    // Run after a short delay to catch dynamically injected elements
    const timeoutId = setTimeout(removeBadges, 500);
    const timeoutId2 = setTimeout(removeBadges, 1500);
    const timeoutId3 = setTimeout(removeBadges, 3000);
    
    // Set up a MutationObserver to catch any dynamically added badges
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          removeBadges();
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(timeoutId2);
      clearTimeout(timeoutId3);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeV3 />} />
          <Route path="/original" element={<Home />} />
          <Route path="/v1" element={<HomeV1 />} />
          <Route path="/v2" element={<HomeV2 />} />
          <Route path="/v3" element={<HomeV3 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
